import React, { useEffect, useRef, useState } from 'react';
import LayoutV2 from '../../../components/layout-v2';
import * as Icon from "ubs-icons"
import { COLOR } from 'ubs-framework/v2/common/constant';
import { useHistory, useLocation } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Validator from "simple-react-validator";
import { sendData } from '../../../store/actions';
import { useDispatch } from 'react-redux';
import { showToastSuccess } from 'ubs-framework/v2/common/function';
import useSocket from '../../common/useSocket';
import { constant, SIGNUP_STEPS } from '../../../common/constant';
import { createCookie } from 'ubs-framework/v2/common/function';
import GTMHandler from '../../common/components/gtm-handler';

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const OTP_TIMEOUT = 30;
const SUBDOMAIN_LP_QUERY_KEY = 'subdomainlp';
const SUBDOMAIN_LP_SESSION_KEY = 'track_signup_subdomainlp';
let interval = null

function useQuery() {
    const query = new URLSearchParams(useLocation().search);
    const queryParams = {};
    query?.forEach((value, key) => {
      queryParams[key] = value;
    });
    return queryParams;
}

const VerifyOTP = () => {
    const params = useQuery();
    const dispatch = useDispatch();
    const history = useHistory();
    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));
    const [otp, setOTP] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [seconds, setSeconds] = useState(0);
    const [disabledBtn, setDisabledBtn] = useState(false);

    const registerDetail = JSON.parse(localStorage.getItem('registerDetail'))

    useEffect(() => {
        if (params?.[SUBDOMAIN_LP_QUERY_KEY] === 'true') {
            sessionStorage.setItem(SUBDOMAIN_LP_SESSION_KEY, 'true');
        }
    }, [params?.[SUBDOMAIN_LP_QUERY_KEY]]);

    useEffect(() => {
        const emailFromParams = params?.email;
        const emailFromStorage = registerDetail?.email;
    
       if (!emailFromStorage) {
            const slugType = localStorage.getItem('slugType') || 'track'
            localStorage.removeItem('signUpStep')
            history.replace(`/${slugType}/register${getSubdomainLpSearch()}`)
        }
    }, []);

    useEffect(() => {
        const expireTime = localStorage.getItem("otp_expire_time");
    
        if (expireTime) {
            const remaining = Math.floor((expireTime - Date.now()) / 1000);
    
            if (remaining > 0) setSeconds(remaining);
            else setSeconds(0);
        }
    }, []);

    useEffect(() => {
        let interval;
    
        if (seconds > 0) {
            interval = setInterval(() => {
                setSeconds(prev => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
    
        return () => clearInterval(interval);
    }, [seconds]);    

    useEffect(() => {
        on();
        return () => off()
    }, [])

    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'account|signUp|verifyAccount': {
                    setTimeout(() => {
                        setDisabledBtn(false)
                        if(res?.data?.token) {
                            createCookie('signup_token', res?.data?.token, constant.COOKIE_DAYS)
                        }
                        if (res?.data?.signUpStep) {
                            localStorage.setItem('signUpStep', res?.data?.signUpStep)
                        }
                        if (res?.data?.orgInfo?.orgId) {
                            localStorage.setItem('signUpOrgId', res?.data?.orgInfo?.orgId)
                        }
                        localStorage.removeItem('otp_expire_time')
                        localStorage.removeItem('registerDetail')
                        showToastSuccess(res?.data?.message || 'OTP verified successfully')
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: "otp_verified"
                        });
                        const slugType = localStorage.getItem('slugType')
                        if ([1]?.includes(res?.data?.signUpStep)) history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}?email=${res?.data?.email}${getSubdomainLpSearch(true)}`)
                        else if ([2]?.includes(res?.data?.signUpStep)) history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}${getSubdomainLpSearch()}`)
                        else if ([3, 4]?.includes(res?.data?.signUpStep)) history.push(`/${res?.data?.orgInfo?.orgId}/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}`)
                    }, 2000);
                    break;
                }
                case 'account|signUp': {
                    if (!res?.data?.token) {
                        setDisabledBtn(false)
                        setSeconds(OTP_TIMEOUT)
                        localStorage.setItem("otp_expire_time", Date.now() + OTP_TIMEOUT * 1000);
                    } 
                    break;
                }
                default:
                    return true;
            }
        } else {
            setDisabledBtn(false)
            setErrorMsg(res.data.error);
            setTimeout(() => setErrorMsg(res.data.error), 5000);
        }
    })

    const verifyOTP = () => {
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            sendData(dispatch, 'account|signUp|verifyAccount', {
                email: params?.email || registerDetail?.email,
                otp: otp
            })
        } else {
            validator?.current?.showMessages()
        }
    }

    const resendOTP = () => {
        sendData(dispatch, 'account|signUp', {
            email: params?.email || registerDetail?.email
        })
    }

    const getSubdomainLpSearch = (hasExistingParams = false) => {
        const isSubdomainLp = params?.[SUBDOMAIN_LP_QUERY_KEY] === 'true' || sessionStorage.getItem(SUBDOMAIN_LP_SESSION_KEY) === 'true';

        if (!isSubdomainLp) return '';

        return `${hasExistingParams ? '&' : '?'}${SUBDOMAIN_LP_QUERY_KEY}=true`;
    }

    const changeEmail = () => {
        localStorage.removeItem('otp_expire_time')
        localStorage.removeItem('signUpStep')
        const slugType = localStorage.getItem('slugType')
        if(slugType) history.push(`/${slugType}/register${getSubdomainLpSearch()}`)
    }

    return (
        <React.Fragment>
            <GTMHandler />
            <LayoutV2 module="" className="u_text-center">
                <div className="u_p-24">
                    <div>
                        <h4 className="u_title u_text-center u_text-bold u_my-16">We’ve emailed your OTP</h4>

                        <p className='u_small-font u_fw-500 u_mt-16 u_mb-12'>
                            We sent an email to <span className='u_color-title'>{params?.email || registerDetail?.email}</span>. Enter the code here or tap the button in the email to continue.
                        </p>

                        <p className='u_small-font u_fw-500'>
                            If you don’t see the email, check your spam or junk folder.
                        </p>
                    </div>

                    {<div className={`u_otp u_mt-24 ${errorMsg ? 'u_mb-15' : 'u_mb-30'}`}>
                        <OtpInput
                            value={otp}
                            onChange={(e) => setOTP(e)}
                            isInputNum={true}
                            containerStyle={'u_otp-container'}
                            inputStyle={'u_otp-input'}
                            numInputs={6}
                            shouldAutoFocus={true}
                            separator={<span> </span>}
                        />
                        
                    </div>}
                    {errorMsg.length !== 0 && <p className="u_error-message u_mb-15">{errorMsg}</p>}
                    {<p className="u_error-message u_mb-15">{validator?.current?.message("otp", otp, "required|min:6")}</p>}

                    <div className="u_block u_relative">
                        <button
                            type="button"
                            onClick={e => verifyOTP(e)}
                            disabled={disabledBtn}
                            className={`u_acc-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.VERIFY_OTP.VERIFY_BUTTON}>Verify
                        </button>
                        {disabledBtn &&
                            <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>
                    <p className="u_mt-10 u_section-text">Didn't you receive the OTP?
                        {seconds === 0 ?
                            <span className="u_cp u_color-title u_ml-6" onClick={e => resendOTP(e, true)} data-testid={TEST_ID.VERIFY_OTP.RESEND_OTP_LINK} >Resend OTP</span>
                            : <span className='u_color-title u_ml-6'>{seconds} Seconds</span>}
                    </p>

                    <p className="u_send-code u_t-center u_mt-24">Entered wrong email? <span className="u_cp" onClick={e => changeEmail()} data-testid={TEST_ID.VERIFY_OTP.CHANGE_EMAIL_LINK} >Change</span></p>

                </div>
            </LayoutV2>
        </React.Fragment>
    );
};

export default VerifyOTP;
